const x_api_key = "NYL5gULPI95mqBHwof8sA5NeX0kVYiygaqDTPUL9";
export default x_api_key;